import { _post } from "../Api";
import { toast } from "react-toastify";

export function closeSpReceipt(spMerchantId, spReceiptId) {
  return _post("/nova/sp_merchant/" + spMerchantId + "/sp_receipt/" + spReceiptId + "/close", {})
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.log(e);
      return Promise.reject();
    })
    .then((res) => {
      toast.success("Saved", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.resolve(res.data);
    });
}
